import { isServer } from './is-client';

export const getWindowWidth = () => {
  if (isServer) return 0;
  return window.innerWidth;
};

export const isMobile = () => {
  const width = getWindowWidth();
  if (width === 0) return false;
  return width <= 767;
};

export const createEvent = (
  name: string,
  bubbles = true,
  cancelable = true,
) => {
  if (typeof Event === 'function') {
    return new Event(name, { bubbles, cancelable });
  } else {
    const event = document.createEvent('Event');
    event.initEvent(name, bubbles, cancelable);

    return event;
  }
};
